<template>
    <div>
        <AppInput
            :name="errorLabel ? errorLabel : label"
            :rules="rules"
            :label="label"
            v-slot="{errors, valid}"
            :row="row"
            :model-value="inputValue"
        >
            <select
                :value="inputValue"
                @change="updateSelect($event.target.value)"
                class="app-native-select"
                :disabled="disabled"
            >
                <option value="" disabled v-if="placeholder">{{ placeholder }}</option>
                <option
                    v-for="item in items"
                    :key="getItemValue(item)"
                    :value="getItemValue(item)"
                >
                    {{ getItemText(item) }}
                </option>
            </select>
        </AppInput>
    </div>
</template>

<script>
import { Field, Form, defineRule, configure } from 'vee-validate'
import { required } from '@vee-validate/rules'
import AppInput from "@/components/forms/AppInput";

configure({
    validateOnInput: true,
    validateOnChange: true,
    validateOnBlur: true,
    validateOnModelUpdate: true,
})

defineRule('required', required)

export default {
    components: {
        AppInput,
        Field,
        Form
    },
    props: {
        value: {
            required: false,
        },
        modelValue: {
            required: false,
        },
        label: {
            required: false,
            type: String
        },
        items: {
            required: true,
            type: Array
        },
        itemText: {
            required: false,
            type: String,
            default: 'text',
        },
        itemValue: {
            required: false,
            type: String,
            default: 'value'
        },
        rules: {

        },
        errorLabel: {
            type: String
        },
        disabled: {
            type: Boolean,
            default: false
        },
        placeholder: {
            default: ''
        },
        outlined: {
            default: true
        },
        color: {
            type: String
        },
        row: {
            type: Boolean
        },
        showDescription: {
            type: Boolean,
            default: false
        }
    },
    name: "AppSelect",
    emits: ['update:modelValue'],
    computed: {
        inputValue() {
            return this.modelValue !== undefined ? this.modelValue : this.value
        }
    },
    methods: {
        updateSelect(val) {
            // Native <select> always returns strings — convert back to original types
            let parsed = val
            if (val === 'true') parsed = true
            else if (val === 'false') parsed = false
            else if (!isNaN(val) && val !== '') parsed = Number(val)
            this.$emit('update:modelValue', parsed)
        },
        getItemValue(item) {
            if (typeof item === 'object' && item !== null) {
                return item[this.itemValue]
            }
            return item
        },
        getItemText(item) {
            if (typeof item === 'object' && item !== null) {
                return item[this.itemText] || item.label || item.name || item[this.itemValue]
            }
            return item
        }
    }
}
</script>

<style scoped>
.app-native-select {
    width: 100%;
    height: 40px;
    margin-bottom: 22px;
    padding: 8px 32px 8px 12px;
    font-size: 14px;
    font-family: inherit;
    border: 1px solid rgba(0, 0, 0, 0.42);
    border-radius: 4px;
    background-color: transparent;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='%23666' d='M7 10l5 5 5-5z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 8px center;
    background-size: 20px;
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    color: rgba(0, 0, 0, 0.87);
}

.app-native-select:hover {
    border-color: rgba(0, 0, 0, 0.87);
}

.app-native-select:focus {
    outline: none;
    border-color: rgb(var(--v-theme-primary));
    border-width: 2px;
    padding: 7px 31px 7px 11px;
}

.app-native-select:disabled {
    background-color: rgba(0, 0, 0, 0.06);
    color: rgba(0, 0, 0, 0.38);
    cursor: not-allowed;
}

.app-native-select option {
    padding: 8px 12px;
}
</style>
